module.exports = __webpack_public_path__ + "static/img/keco-vinyl.0a754df.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/visual-marketing/keco-vinyl.jpg
// module id = c44X
// module chunks = 0